import { Tooltip } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../../../../Components/Button"
import ExportDropdown from "../../../../../../Components/Export"
import Icon from "../../../../../../Icon"

import styles from "./disputesHeaderActions.module.less"

// Mobile page-header actions (Sync, Export). Registered through TitleSectionContext
// from AllPage, the same way ReceiptPage registers its header actions — the title row
// always renders `{action}`, so there is no DOM node to look up and nothing to portal
// into. Both buttons are icon-only: the header row has no width for two labels beside
// the page title, and the same buttons keep their labels on desktop.
const DisputesHeaderActions = ({ syncing, exporting, count, onSync, onExport }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.actions}>
      <Tooltip title={t("Disputes sync automatically every hour. Click to refresh now.")}>
        <Button
          className="center"
          loading={syncing}
          aria-label={t("Sync disputes")}
          icon={<Icon type="arrows_rotate" style={{ fontSize: 20 }} />}
          onClick={onSync}
        />
      </Tooltip>
      {/* `inHeader` is what drops the "Export" label, the same flag ReceiptPage's header
          export uses — the page stylesheet used to zero the font size to hide it. */}
      <ExportDropdown
        loading={exporting}
        onExport={onExport}
        exportAsFiltered
        disabled={!count}
        iconButton
        inHeader
      />
    </div>
  )
}

export default DisputesHeaderActions
